import axios from 'axios';
import { getApiBase } from '../native/tenant';
import { clearSession, refreshSession } from './session';

// Web: relative "/api". Native app: the entered tenant origin + "/api".
const api = axios.create({
  baseURL: `${getApiBase()}/api`,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});


api.interceptors.response.use(
  (res) => res,
  async (err) => {
    const original = err.config || {};
    if (
      err.response?.status === 401 &&
      localStorage.getItem('refresh_token') &&
      !original.__retried
    ) {
      original.__retried = true;
      const newToken = await refreshSession();
      if (newToken) {
        original.headers = { ...(original.headers || {}), Authorization: `Bearer ${newToken}` };
        return api(original);
      }
    }
    if (err.response?.status === 403 && err.response?.data?.detail === 'Password change required') {
      window.dispatchEvent(new Event('cad:password-change-required'));
    }
    if (err.response?.status === 401) {
      const path = window.location.pathname;
      // Don't redirect on login/public pages — let the page handle the error.
      // The board kiosk authenticates via a token in the URL, not a session.
      if (path === '/login' || path === '/mdt' || path.startsWith('/board')) {
        return Promise.reject(err);
      }
      clearSession();
      // Redirect MDT users back to MDT login
      if (path.startsWith('/mobile/')) {
        window.location.href = '/mdt';
      } else {
        window.location.href = '/login';
      }
    }
    return Promise.reject(err);
  }
);

export default api;
